import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { deruptFeedContractAddress, stacksApi } from '../../lib/constants';
import { Badge } from '@mui/material';
import './style.scss';

export default function LoadNewChimesChip({ chimeResults, setChimeResults, userSettings }) {
  const [show, setShow] = useState(false);
  const [newChimes, setNewChimes] = useState([]);

  function scrollToTop() { window.scrollTo({ top: 0, behavior: 'smooth' }); }

  async function loadRecentChimes() {
    if (newChimes.length === 0) return
    setChimeResults([...newChimes, ...chimeResults]);
    setNewChimes([]);
    setShow(false);
    scrollToTop();
  }

  async function checkNewChimes() {
    let filteredNewChimes = [];
    try {
      const results = (await axios.get(`${userSettings?.stacksApi || stacksApi}/extended/v1/contract/${deruptFeedContractAddress}/events?limit=5`))?.data?.results;
      // Filter results
      const prevChimeTx = new Set(chimeResults.map(({ tx_id }) => tx_id));
      for (const key in results) {
        if (!prevChimeTx.has(results[key].tx_id)) {
          filteredNewChimes.push(results[key]);
        }
      }
      // Checks if new chimes are below 10 add's them to the feed list or reloads page if new chimes are above 10
      if ((filteredNewChimes.length < 10 && filteredNewChimes.length > 0)) {
        setNewChimes(filteredNewChimes);
        if (show === false) setShow(true);
      } else if (filteredNewChimes.length > 10) {
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleClick = () => {
    loadRecentChimes();
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      checkNewChimes();
    }, 60000);
    return () => clearInterval(intervalId);
  }, [chimeResults, newChimes]);

  useEffect(() => {
    console.log(newChimes);
  }, [newChimes])

  return (
    <>
      {show === true &&
        <div className='chip'>
          <Stack direction="row" spacing={1}>
            <Badge badgeContent={newChimes.length} color='warning' anchorOrigin={{ vertical: 'top', horizontal: 'left', }}>
              <Chip label="Load New" onClick={handleClick} />
            </Badge>
          </Stack>
        </div>
      }
    </>
  );
}